import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as firebase from 'firebase';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { callNgModuleLifecycle } from '@angular/core/src/view/ng_module';

@Component({
  selector: 'app-novi-pacijent',
  templateUrl: './novi-pacijent.component.html',
  styleUrls: ['./novi-pacijent.component.css']
})
export class NoviPacijentComponent implements OnInit {
  today: number = Date.now();
  dan: number;
  mesec: number;
  godina: number;
  danAlert = false;
  pacijentiRef: Array<any> = [];
  @ViewChild('alert') alert: ElementRef;
  constructor(private router: Router) {}

  ngOnInit() {
    // firebase
    //   .database()
    //   .ref('pacijenti')
    //   .on('child_added', snap => {
    //     this.pacijentiRef.push({ key: snap.key });
    //   });
  }

  onSubmit(form: NgForm) {
    const ime = form.value.ime;
    const prezime = form.value.prezime;
    const telefon = form.value.telefon;
    const email = form.value.email;
    let dan = String(form.value.dan);
    let mesec = String(form.value.mesec);
    const godina = form.value.godina;
    const adresa = form.value.adresa;
    // const pacijentKey = this.pacijentiRef.map(i =>
    //   firebase.database().ref(`/pacijenti/${i.key}`)
    // );

    // const query = pacijentKey.map(i => {
    //   i.orderByChild('Ime').equalTo(ime);
    //   console.log(query);
    // });

    const key = new Date().valueOf().toLocaleString();
    if (dan.length < 2) {
      dan = '0' + dan;
    }
    if (mesec.length < 2) {
      mesec = '0' + mesec;
    }
    if (Number(dan) > 31 || Number(dan) <= 0) {
      alert('Format dana rodjenja: 1 - 31');
      return !form.valid;
    }
    if (Number(mesec) > 12 || Number(mesec) <= 0) {
      alert('Format meseca rodjenja: 1 - 12');
      return !form.valid;
    }
    if (godina.length < 4) {
      alert('Godina rodjenja mora da ima cetiri cifre!');
      return !form.valid;
    }

    const newDatum = `${dan}.${mesec}.${godina}.`;

    firebase
      .database()
      .ref('pacijenti')
      .child(key)
      .set({
        Ime: ime,
        Prezime: prezime,
        Telefon: telefon,
        DatumRodjenja: newDatum,
        Adresa: adresa,
        Email: email,
        DatumUbacivanja: this.today
      })
      .then(() => {
        this.router.navigate(['/']);
      });
  }
  close() {
    this.alert.nativeElement.style.display = 'none';
  }
}
